import { Buffer } from 'buffer';
import { install } from 'resize-observer';

export default function initPolyfills() {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!window.ResizeObserver) install();

  // AWS SDK v3 (loaded transitively by @aws-amplify/geo@3.x) references the
  // Node `Buffer` global in some signing paths. Polyfill it on the window so
  // the bare `Buffer.from(...)` calls don't ReferenceError in the browser.
  if (typeof globalThis.Buffer === 'undefined') {
    globalThis.Buffer = Buffer;
  }
}
